// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../components-core/flex-dashboard';
import AddShelf from './add-shelf';

// Configs
import getDashboardConfig from '../configs/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                id: 'ADDSHELF',
                                type: 'tab',
                                name: '',
                                component: AddShelf,
                            },
                        ],
                    },
                ],
            },
        ],
    },
};

const ShelfDetailDashboard = () => (
    <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="shelfItems" />
);

export default ShelfDetailDashboard;
